angular.module('homebot.directives')

.directive('positiveUnder', [function(){
  return {
    restrict: 'A',
    link: function(scope, el, attrs){
      attrs.$observe('value', function(newVal){
        let positiveUnder = attrs.positiveUnder || 0;
        positiveUnder = parseInt(positiveUnder);
        newVal = parseInt(newVal);

        if(newVal < positiveUnder)
          el.addClass('text-positive').removeClass('text-danger');
        else
          el.addClass('text-danger').removeClass('text-positive');
      });
    }
  }
}]);
